<template>
  <div class="hero-slide">
    <div class="slide">
      <picture class="slide-picture">
        <source media="(max-width: 767px)" :srcset="images.img375" />
        <source media="(max-width: 1023px)" :srcset="images.img768" />
        <source media="(max-width: 1279px)" :srcset="images.img1024" />
        <source media="(max-width: 1439px)" :srcset="images.img1280" />
        <source media="(max-width: 1919px)" :srcset="images.img1440" />
        <img
          class="slide-image"
          :src="images.img1920"
          :alt="imageAlt"
        />
      </picture>
      <div class="slide-text">
        <div class="slide-text-inner">
          <div v-if="line1" class="slide-line1">{{ line1 }}</div>
          <div v-if="line2" class="slide-line2">{{ line2 }}</div>
          <div v-if="line3" class="slide-line3">{{ line3 }}</div>
        </div>
      </div>
      <PromoBanner />
    </div>
  </div>
</template>

<script>
import PromoBanner from '@/components/main/PromoBanner';

export default {
  name: 'MainHeroSlide',
  components: {
    PromoBanner,
  },
  props: {
    images: {
      type: Object,
      required: true,
    },
    line1: {
      type: String,
      default: '',
    },
    line2: {
      type: String,
      default: '',
    },
    line3: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: 'Lead image',
    },
  },
};
</script>

<style scoped>
.hero-slide {
  width: 100%;
  height: 140vw;
}

@media screen and (min-width: 580px) {
  .hero-slide {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .hero-slide {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .hero-slide {
    height: calc(100vh - 192px);
  }
}

.slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.slide-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

.slide-text-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .slide-text {
    width: 50%;
    justify-content: center;
    padding: 0 40px;
  }

  .slide-text-inner {
    max-width: 600px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-text-inner {
    gap: 20px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-text {
    padding: 0 80px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-text {
    padding: 0 120px;
  }

  .slide-text-inner {
    max-width: 720px;
  }
}

.slide-line1 {
  white-space: pre-line;
  line-height: 1.2;
  text-transform: uppercase;
  font-weight: 700;
}

.slide-line2 {
  white-space: pre-line;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 700;
}

.slide-line3 {
  white-space: pre-line;
  line-height: 1.2;
  font-weight: 400;
}

.slide-line1 {
  font-size: 20px;
}

.slide-line2 {
  font-size: 32px;
}

.slide-line3 {
  font-size: 18px;
}

@media screen and (min-width: 768px) {
  .slide-line1 {
    font-size: 22px;
  }

  .slide-line2 {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-line1 {
    font-size: 28px;
  }

  .slide-line2 {
    font-size: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-line1 {
    font-size: 32px;
  }

  .slide-line2 {
    font-size: 66px;
  }

  .slide-line3 {
    font-size: 22px;
  }
}
</style>
